export default {
  LOADING: 'LOADING',
  NO_DATA: 'NO_DATA',
  NO_RESULTS: 'NO_RESULTS',
  TABLE: 'TABLE'
};